import axios from "axios";

const testListError = false;
const testContactsError = false;
const testAgentsError = false;

const initErrorTesting = () => {
    if(testListError) testListErrorInterceptor();
    if(testContactsError) testContactsErrorInterceptor();
    if(testAgentsError) testAgentsErrorInterceptor();
};

const testListErrorInterceptor = () => {
  return axios.interceptors.request.use((config) => {
    if (config.url?.includes("/cdk-collections/v2/lists")) {
      return Promise.reject({
        response: {
          data: { message: "Intercepted test error" },
          status: 500,
          statusText: "Test Error",
        },
        message: "Intercepted test error",
        config,
      });
    }
    return config;
  });
};

const testContactsErrorInterceptor = () => {
  return axios.interceptors.request.use((config) => {
    if (config.url?.includes("/cdk-collections/v2/leads")) {
      return Promise.reject({
        response: {
          data: { message: "Intercepted test error" },
          status: 500,
          statusText: "Test Error",
        },
        message: "Intercepted test error",
        config,
      });
    }
    return config;
  });
};

const testAgentsErrorInterceptor = () => {
  return axios.interceptors.request.use((config) => {
    if (
      config.url?.includes("/cdk-collections/v2") &&
      config.url?.includes("agent")
    ) {
      return Promise.reject({
        response: {
          data: { message: "Intercepted test error" },
          status: 500,
          statusText: "Test Error",
        },
        message: "Intercepted test error",
        config,
      });
    }
    return config;
  });
};

export {
  initErrorTesting,
  testAgentsErrorInterceptor,
  testListErrorInterceptor,
  testContactsErrorInterceptor,
};
